document.addEventListener('DOMContentLoaded', () => {
    const images = document.querySelectorAll('[js-animation-container] [js-animation-image]');
    const stats = document.querySelectorAll('[js-animation-container] [js-animation-text]');

    if (images.length <= 1) return;

    let currentIndex = 0;
    const animationTime = 1500;
		let isAnimating = false;
    let interval = null;

		let resetState = () => {
			currentIndex = 0;
    	interval = null;
			images.forEach((image) => {
				image.classList.remove("active");
				image.classList.remove("is-entering");
				image.classList.remove("not-active");
				image.classList.remove("is-enter-start");

				console.log("this is the image classlist", image.classList);
			});
			stats.forEach((stat) => {
				stat.classList.remove('active');
			});
		}

    function setActiveState(index) {
			if (isAnimating) return;
			isAnimating = true;

			index = (index + images.length -1) % images.length;
			const currentImage = images[index];
			const nextIndex = (index + 1) % images.length;
			const nextImage = images[nextIndex];

			currentImage.classList.remove('active');
			currentImage.classList.add('not-active');

			nextImage.classList.remove('active', 'not-active', 'is-entering');
			nextImage.classList.add('is-enter-start');

			nextImage.offsetHeight;

			nextImage.classList.remove('is-enter-start');
			nextImage.classList.add('is-entering');

			setTimeout(() => {
				currentImage.classList.remove('not-active');

				nextImage.classList.remove('is-entering');
				nextImage.classList.add('active');

				currentIndex = nextIndex;
				isAnimating = false;
			}, animationTime);

      
			if (index == 3) {
				stats.forEach((stat) => {
					stat.classList.remove('active');
				});
			} else {
				for (let i = 0; i < stats.length; i ++) {
					if (i <= index) {
						stats[i].classList.add('active');
					}
				}
			}
    }

    function nextState() {
			if (currentIndex == 3) stopAnimation();
			else {
				currentIndex = (currentIndex + 1) % images.length;
				setActiveState(currentIndex);
			}
    }

    function startAnimation() {
      if (interval) clearInterval(interval);
      interval = setInterval(nextState, 2200);
    }

    function stopAnimation() {
      if (interval) clearInterval(interval);
    }

    // setActiveState(currentIndex);
    // startAnimation();

	const target = document.querySelector('.pdp-product-hero');
	const observer = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				console.log('Element is visible!');
				
				// 👉 your function here
				resetState();
				setActiveState(currentIndex);
				startAnimation();

				// optional: run only once
				// observer.unobserve(entry.target);
			}
		});
	}, {
		threshold: 0.3 // 30% visible
	});

	let is_beginning = true;
	if (target) {
		if (is_beginning) {
			setTimeout(() => {
				observer.observe(target);
			}, 2500);
			
			is_beginning = false;
		} else {
			observer.observe(target);
		}
	}

});